import Swiper from 'swiper/bundle';
import gsap from "gsap";
import {DotLottie} from '@lottiefiles/dotlottie-web';

$(document).ready(function () {

    // slider mobile

    let slider_counter_boxes_swiper = null;
    function initCounterBoxesSlider() {
        const sliderSelector = ".slider-counter-boxes.swiper-container";
        const mediaQuery = window.matchMedia("(max-width: 1023px)");

        function enableSwiper() {
            if (!slider_counter_boxes_swiper && document.querySelector(sliderSelector)) {
                slider_counter_boxes_swiper = new Swiper(sliderSelector, {
                    slidesPerView: 'auto',
                    loop: false,

                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    navigation: {
                        nextEl: ".section-counter-boxes .swiper-button-next.slider-counter-boxes-swiper-button",
                        prevEl: ".section-counter-boxes .swiper-button-prev.slider-counter-boxes-swiper-button",
                    },
                    pagination: {
                        el: ".section-counter-boxes .swiper-pagination",
                        clickable: true,
                    },
                });
            }
        }

        function disableSwiper() {
            if (slider_counter_boxes_swiper) {
                slider_counter_boxes_swiper.destroy(true, true);
                slider_counter_boxes_swiper = null;
            }
        }

        function checkBreakpoint(e) {
            if (e.matches) {
                enableSwiper();
            } else {
                disableSwiper();
            }
        }

        checkBreakpoint(mediaQuery);
        mediaQuery.addEventListener("change", checkBreakpoint);
    }
    initCounterBoxesSlider();


    // numbers animation
    function startAnimationNumbers() {
        const items = document.querySelectorAll(".section-counter-boxes .number");

        items.forEach((item) => {
            const raw = String(item.dataset.target || item.textContent || '').trim().replace(',', '.');
            const target = parseFloat(raw);
            if (isNaN(target)) {
                return;
            }

            // number of decimals as entered in ACF (no rounding)
            const decimals = raw.includes('.') ? raw.split('.')[1].length : 0;
            const proxy = {value: 0};

            gsap.to(proxy, {
                value: target,
                duration: 4,
                ease: "Power1.easeIn",
                onUpdate() {
                    // count up with whole numbers, same as before
                    item.textContent = Math.floor(proxy.value).toString();
                },
                onComplete() {
                    // final value: exact, comma as decimal separator
                    item.textContent = target.toFixed(decimals).replace('.', ',');
                },
            });
        });
    }

    let animationTriggered = false;
    $(window).on('scroll', function () {
        const $section = $('.section-counter-boxes');
        const sectionTop = $section.offset().top;
        const triggerPoint = $(window).scrollTop() + $(window).height() / 1.5;

        // Check if animations should be triggered
        if (!animationTriggered && sectionTop < triggerPoint) {
            startAnimationNumbers();
            animationTriggered = true; // Set flag to prevent re-triggering
        }
    });


    // lottie animation
    const lottieCanvasBox = $('#dotlottie-canvas-counter-boxes');
    const lottieCanvas = lottieCanvasBox.find('canvas');

    if (lottieCanvas.length > 0) {
        const lottieSrc = lottieCanvas.data('src');
        const lottieLoop = lottieCanvas.data('loop');

        const dotLottie = new DotLottie({
            autoplay: true,
            loop: lottieLoop,
            canvas: lottieCanvas[0],
            src: lottieSrc
        });
    }
});

